<template>
  <div class="footer">
    <div class="inner clearfix">
      <div class="logo"><img src="../assets/logo2.png"/></div>
      <div class="text">
        <h4>联系我们</h4>
        <div class="grey addr">地址：苏州市姑苏区西环路888号    客服电话:0512-68508176</div>
        <div class="grey cr">Gold Mantis © copyright 2013 苏ICP备05065917号</div>
      </div>
      <div class="code">
        <img src="../assets/code.png" />
        <div class="grey">微信公众号</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="scss" scope>
  @import '../scss/layouts/footer';
</style>